import Stack from '@mui/material/Stack';
import { useEventContext } from 'contexts';
import { Link } from 'react-router-dom';
import { NavUtils, NavPages } from 'utils';

interface Props {
    message: string;
    includeRootLink?: boolean;
}

export const PageMessage = (props: Props) => {
    const event = useEventContext();
    return (
        <div className="aq-content">
            <Stack spacing={2}>
                <p>{props.message}</p>
                {props.includeRootLink && (
                    <Link to={NavUtils.generateNavPath(NavPages.Root, undefined, event?.alias)}>Return to quiz list</Link>
                )}
            </Stack>
        </div>
    );
};
